module.exports = __webpack_public_path__ + "static/media/mode-28.372f5993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-28.svg
// module id = 1001
// module chunks = 2